/* irh-share.js: the share-your-recipe form (2026-10-13).
   Sends to the Google Apps Script web app in data-endpoint in three steps, so one slow photo does not lose the
   whole recipe:  start (the text) -> chunk (each file, one request each) -> finish (emails go out).
   Text is saved as a draft in this browser while typing, so a closed tab does not lose a recipe. */
(function () {
  'use strict';
  var root = document.querySelector('[data-irh-share]');
  if (!root || !window.IRH) return;
  var X = window.IRH, esc = X.esc;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var form = $('#irh-form'), ENDPOINT = root.getAttribute('data-endpoint') || '';
  var opened = Date.now(), DRAFT = 'irh-share-draft';
  /* one request per file: a 30 MB video is ~40 MB as text, inside Apps Script's 50 MB limit */
  var MAX_PHOTOS = 6, MAX_VIDEO = 30 * 1024 * 1024, CHUNK = 32 * 1024 * 1024;

  /* ---------------- choices ---------------- */
  function fill(sel, list, other) {
    sel.innerHTML = '<option value="">Choose…</option>' + list.map(function (e) { return '<option value="' + esc(e[1]) + '">' + esc(e[1]) + '</option>'; }).join('') + (other ? '<option value="Other">' + other + '</option>' : '');
  }
  fill($('#f-cui'), X.CUI.slice().sort(function (a, b) { return a[1].localeCompare(b[1]); }), 'Other / my own');
  fill($('#f-meal'), X.MEAL, 'Other');

  /* ---------------- ingredient + step rows ---------------- */
  function rowsBox(name) { return $('[data-rows="' + name + '"]'); }
  function addRow(name, value, focus) {
    var box = rowsBox(name), n = box.children.length + 1;
    var row = document.createElement('div'); row.className = 'irh-row';
    row.innerHTML = '<i>' + n + '</i><input type="text" maxlength="300" aria-label="' + (name === 'steps' ? 'Step ' : 'Ingredient ') + n + '" placeholder="' + esc(box.getAttribute('data-placeholder')) + '"><button type="button" aria-label="Remove">×</button>';
    var inp = row.querySelector('input'); inp.value = value || '';
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); var next = row.nextElementSibling; if (next) next.querySelector('input').focus(); else addRow(name, '', true); }
      if (e.key === 'Backspace' && !inp.value && box.children.length > +box.getAttribute('data-min')) { e.preventDefault(); var prev = row.previousElementSibling; row.remove(); renumber(name); if (prev) prev.querySelector('input').focus(); saveDraft(); }
    });
    /* pasting a whole list fills one row per line */
    inp.addEventListener('paste', function (e) {
      var t = (e.clipboardData || window.clipboardData).getData('text');
      var parts = t.split(/\r?\n/).map(function (s) { return s.replace(/^\s*(?:[-•*]|\d+[.)])\s*/, '').trim(); }).filter(Boolean);
      if (parts.length < 2) return;
      e.preventDefault();
      inp.value = parts.shift();
      var after = row;
      parts.forEach(function (p) { var r = addRow(name, p); box.insertBefore(r, after.nextSibling); after = r; });
      renumber(name); saveDraft();
    });
    row.querySelector('button').addEventListener('click', function () {
      if (box.children.length <= +box.getAttribute('data-min')) { inp.value = ''; return; }
      row.remove(); renumber(name); saveDraft();
    });
    box.appendChild(row);
    if (focus) inp.focus();
    return row;
  }
  function renumber(name) { Array.prototype.forEach.call(rowsBox(name).children, function (r, i) { r.querySelector('i').textContent = i + 1; }); }
  function rowValues(name) { return Array.prototype.map.call(rowsBox(name).children, function (r) { return r.querySelector('input').value.trim(); }).filter(Boolean); }
  $$('[data-addrow]').forEach(function (b) { b.addEventListener('click', function () { addRow(b.getAttribute('data-addrow'), '', true); }); });

  /* ---------------- iSpice spice chips (from the recipe library) ---------------- */
  var picked = [];
  X.load(root.getAttribute('data-feed')).then(function (all) {
    var c = {};
    all.forEach(function (r) { r.x.forEach(function (p) { var t = X.shortTitle(p.t); if (t) c[t] = (c[t] || 0) + 1; }); });
    var names = Object.keys(c).sort(function (a, b) { return c[b] - c[a]; }).slice(0, 36);
    $('#irh-spice-pick').innerHTML = names.map(function (n) { return '<button class="irh-chip" type="button" aria-pressed="' + (picked.indexOf(n) > -1) + '" data-spice="' + esc(n) + '">' + esc(n) + '</button>'; }).join('');
  }).catch(function (e) { console.warn('irh-share: spice list', e); $('#irh-spice-pick').innerHTML = ''; });
  $('#irh-spice-pick').addEventListener('click', function (e) {
    var b = e.target.closest('[data-spice]'); if (!b) return;
    var n = b.getAttribute('data-spice'), i = picked.indexOf(n);
    if (i > -1) picked.splice(i, 1); else picked.push(n);
    b.setAttribute('aria-pressed', i < 0); saveDraft();
  });

  /* ---------------- photos + video ---------------- */
  var files = [];   /* {kind:'photo'|'video', blob, name, url} */
  var drop = $('#irh-drop'), input = $('#f-files');
  drop.addEventListener('click', function () { input.click(); });
  drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); } });
  ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
  ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
  drop.addEventListener('drop', function (e) { addFiles(e.dataTransfer.files); });
  input.addEventListener('change', function () { addFiles(input.files); input.value = ''; });

  function addFiles(list) {
    var err = $('#err-files'); err.textContent = '';
    Array.prototype.forEach.call(list, function (f) {
      if (/^video\//.test(f.type)) {
        if (files.some(function (x) { return x.kind === 'video'; })) { err.textContent = 'One video at a time. For a longer one, paste a link below.'; return; }
        if (f.size > MAX_VIDEO) { err.textContent = 'That video is ' + Math.round(f.size / 1048576) + ' MB. The limit is 30 MB. Paste a YouTube or TikTok link instead.'; return; }
        files.push({ kind: 'video', blob: f, name: f.name, url: URL.createObjectURL(f) });
        drawThumbs();
      } else if (/^image\//.test(f.type) || /\.(heic|heif)$/i.test(f.name)) {
        if (files.filter(function (x) { return x.kind === 'photo'; }).length >= MAX_PHOTOS) { err.textContent = 'Up to 6 photos.'; return; }
        var item = { kind: 'photo', blob: f, name: f.name, url: '' };
        files.push(item);
        shrink(f).then(function (small) { item.blob = small; item.name = small === f ? f.name : f.name.replace(/\.[^.]+$/, '') + '.jpg'; item.url = URL.createObjectURL(small); drawThumbs(); });
      } else err.textContent = 'Photos (JPG, PNG, HEIC) or one video, please.';
    });
    drawThumbs();
  }
  /* big phone photos are made 2000 px wide JPEGs before sending; if the browser cannot read the format (HEIC
     outside Safari) the original is sent as it is, up to 15 MB */
  function shrink(f) {
    return new Promise(function (resolve) {
      var img = new Image(), u = URL.createObjectURL(f);
      img.onload = function () {
        var max = 2000, w = img.naturalWidth, h = img.naturalHeight, k = Math.min(1, max / Math.max(w, h));
        var cv = document.createElement('canvas'); cv.width = Math.round(w * k); cv.height = Math.round(h * k);
        cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
        URL.revokeObjectURL(u);
        cv.toBlob(function (b) { resolve(b && b.size < f.size ? b : f); }, 'image/jpeg', .86);
      };
      img.onerror = function () { URL.revokeObjectURL(u); resolve(f); };
      img.src = u;
    });
  }
  function drawThumbs() {
    var photos = files.filter(function (x) { return x.kind === 'photo'; });
    $('#irh-thumbs').innerHTML = files.map(function (x, i) {
      var cover = x.kind === 'photo' && photos[0] === x;
      return '<div class="irh-thumb' + (cover ? ' is-cover' : '') + '">' +
        (x.kind === 'video' ? '<video src="' + esc(x.url) + '" muted playsinline></video><span>Video</span>' : (x.url ? '<img src="' + esc(x.url) + '" alt="">' : '<span>Preparing…</span>')) +
        '<button type="button" data-rm-file="' + i + '" aria-label="Remove">×</button>' +
        (x.kind === 'photo' && !cover ? '<button type="button" data-cover="' + i + '" style="left:6px;right:auto;bottom:6px;top:auto;width:auto;padding:0 8px;border-radius:999px;font-size:11px">Make cover</button>' : '') +
      '</div>';
    }).join('');
  }
  $('#irh-thumbs').addEventListener('click', function (e) {
    var r = e.target.closest('[data-rm-file]'), c = e.target.closest('[data-cover]');
    if (r) { var i = +r.getAttribute('data-rm-file'); if (files[i].url) URL.revokeObjectURL(files[i].url); files.splice(i, 1); drawThumbs(); }
    if (c) { var j = +c.getAttribute('data-cover'), it = files.splice(j, 1)[0]; files.unshift(it); drawThumbs(); }
  });

  /* ---------------- draft (this browser only) ---------------- */
  var FIELDS = ['name', 'email', 'city', 'social', 'title', 'cuisine', 'meal', 'story', 'prep', 'cook', 'servings', 'tips', 'spices_other', 'video_link'];
  var draftTimer;
  function saveDraft() {
    clearTimeout(draftTimer);
    draftTimer = setTimeout(function () {
      var d = { at: Date.now(), ing: rowValues('ingredients'), steps: rowValues('steps'), spices: picked };
      FIELDS.forEach(function (k) { var el = form.elements[k]; if (el) d[k] = el.value; });
      X.store(DRAFT, d);
    }, 400);
  }
  function loadDraft() {
    var d = X.store(DRAFT);
    if (!d || Date.now() - d.at > 14 * 86400e3) d = null;
    FIELDS.forEach(function (k) { var el = form.elements[k]; if (el && d && d[k]) el.value = d[k]; });
    var ing = d && d.ing && d.ing.length ? d.ing : [], st = d && d.steps && d.steps.length ? d.steps : [];
    for (var i = 0; i < Math.max(3, ing.length); i++) addRow('ingredients', ing[i] || '');
    for (var j = 0; j < Math.max(2, st.length); j++) addRow('steps', st[j] || '');
    picked = d && d.spices ? d.spices : [];
  }
  loadDraft();
  form.addEventListener('input', saveDraft);

  /* ---------------- checking ---------------- */
  function bad(id, msg) {
    var el = $('#' + id), f = el && el.closest('.irh-field');
    if (f) { f.classList.add('is-bad'); var e = f.querySelector('.irh-err'); if (e) e.textContent = msg; }
    return el;
  }
  function check() {
    $$('.irh-field.is-bad').forEach(function (f) { f.classList.remove('is-bad'); var e = f.querySelector('.irh-err'); if (e) e.textContent = ''; });
    ['err-ingredients', 'err-steps', 'err-files', 'err-consent'].forEach(function (id) { $('#' + id).textContent = ''; });
    var first = null, E = form.elements;
    function need(id, ok, msg) { if (!ok) { var el = bad(id, msg); first = first || el; } }
    need('f-name', E.name.value.trim().length > 1, 'Your name, please.');
    need('f-email', /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(E.email.value.trim()), 'A valid email, so we can send your gift card.');
    need('f-title', E.title.value.trim().length > 2, 'Give your recipe a name.');
    need('f-cui', !!E.cuisine.value, 'Choose a cuisine.');
    need('f-meal', !!E.meal.value, 'Choose a meal type.');
    need('f-prep', E.prep.value !== '' && +E.prep.value >= 0, 'Minutes to prepare.');
    need('f-cook', E.cook.value !== '' && +E.cook.value >= 0, 'Minutes to cook (0 if no cooking).');
    need('f-serv', +E.servings.value >= 1, 'How many people it serves.');
    if (rowValues('ingredients').length < 3) { $('#err-ingredients').textContent = 'At least 3 ingredients.'; first = first || rowsBox('ingredients'); }
    if (rowValues('steps').length < 2) { $('#err-steps').textContent = 'At least 2 steps.'; first = first || rowsBox('steps'); }
    if (!files.some(function (x) { return x.kind === 'photo'; })) { $('#err-files').textContent = 'Add at least one photo of the finished dish.'; first = first || drop; }
    if (!E.own.checked || !E.license.checked || !E.rules.checked) { $('#err-consent').textContent = 'Please tick the three boxes marked *.'; first = first || $('#err-consent'); }
    if (first) { first.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (first.focus) setTimeout(function () { first.focus({ preventScroll: true }); }, 350); }
    return !first;
  }

  /* ---------------- sending ---------------- */
  function post(body) {
    /* text/plain keeps this a "simple" request: Apps Script web apps cannot answer a CORS preflight */
    return fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(body), redirect: 'follow' })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (!j || !j.ok) throw new Error((j && j.error) || 'The server said no.'); return j; });
  }
  function b64(blob) {
    return new Promise(function (resolve, reject) {
      var fr = new FileReader();
      fr.onload = function () { resolve(String(fr.result).split(',')[1] || ''); };
      fr.onerror = function () { reject(fr.error); };
      fr.readAsDataURL(blob);
    });
  }
  var sending = false;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (sending || !ENDPOINT) return;
    if (form.elements.website.value) return;                       /* a bot filled the hidden field */
    if (!check()) return;
    if (Date.now() - opened < 8000) { $('#irh-submit-note').textContent = 'One moment… please check your recipe once more, then send.'; return; }
    sending = true;
    var btn = $('#irh-submit'), note = $('#irh-submit-note'), bar = $('#irh-up'), fillBar = bar.querySelector('i');
    btn.disabled = true; bar.hidden = false; fillBar.style.width = '4%';
    note.textContent = 'Sending your recipe…';
    var E = form.elements;
    var data = {
      name: E.name.value.trim(), email: E.email.value.trim(), city: E.city.value.trim(), social: E.social.value.trim(), show_name: E.show_name.checked,
      title: E.title.value.trim(), cuisine: E.cuisine.value, meal: E.meal.value, story: E.story.value.trim(),
      prep: +E.prep.value, cook: +E.cook.value, servings: +E.servings.value,
      ingredients: rowValues('ingredients'), steps: rowValues('steps'), tips: E.tips.value.trim(),
      spices: picked, spices_other: E.spices_other.value.trim(), video_link: E.video_link.value.trim(),
      news: E.news.checked, page: location.href.split('?')[0]
    };
    /* total bytes, so the bar moves with the upload */
    var total = files.reduce(function (s, f) { return s + f.blob.size; }, 0) || 1, done = 0, id, token;
    post({ action: 'start', data: data }).then(function (r) {
      id = r.id; token = r.token;
      var seq = Promise.resolve(), sent = [];
      files.forEach(function (f, n) {
        var key = (f.kind === 'video' ? 'video' : 'photo-' + (n + 1)) + '-' + f.name.replace(/[^\w.-]+/g, '_').slice(-60);
        var parts = Math.max(1, Math.ceil(f.blob.size / CHUNK));
        for (var k = 0; k < parts; k++) (function (k) {
          seq = seq.then(function () {
            var piece = f.blob.slice(k * CHUNK, Math.min(f.blob.size, (k + 1) * CHUNK));
            note.textContent = 'Uploading ' + (f.kind === 'video' ? 'your video' : 'photo ' + (n + 1)) + (parts > 1 ? ' (' + (k + 1) + ' of ' + parts + ')' : '') + '…';
            return b64(piece).then(function (d64) {
              return post({ action: 'chunk', id: id, token: token, file: { key: key, name: f.name, type: f.blob.type || 'application/octet-stream', index: k, total: parts, data: d64 } });
            }).then(function () { done += piece.size; fillBar.style.width = Math.max(6, Math.round(92 * done / total)) + '%'; });
          });
        })(k);
        seq = seq.then(function () { sent.push({ key: key, kind: f.kind }); });
      });
      return seq.then(function () { note.textContent = 'Finishing…'; return post({ action: 'finish', id: id, token: token, files: sent }); });
    }).then(function () {
      fillBar.style.width = '100%';
      try { localStorage.removeItem(DRAFT); } catch (err) { console.warn('irh-share: draft', err); }
      form.hidden = true;
      var d = $('#irh-done'); d.hidden = false; d.focus(); d.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }).catch(function (err) {
      console.warn('irh-share: send failed', err);
      note.textContent = 'Sorry, that did not go through (' + (err.message || 'network') + '). Your text is saved here; please try again in a minute.';
      btn.disabled = false; bar.hidden = true;
    }).then(function () { sending = false; });
  });
  $$('[data-again]').forEach(function (b) { b.addEventListener('click', function () { location.reload(); }); });
})();
